import { useEffect, useState } from "react";
import { ws, type ConnectionStatus } from "../api/ws";

export function ConnectionBanner() {
  const [status, setStatus] = useState<ConnectionStatus>(ws.status());

  useEffect(() => ws.onStatus(setStatus), []);

  if (status === "open" || status === "idle") return null;

  const message =
    status === "connecting"
      ? "Connecting to hub…"
      : status === "reconnecting"
        ? "Reconnecting to hub…"
        : "Disconnected";

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed left-1/2 top-[64px] z-[60] -translate-x-1/2"
    >
      <div className="card flex items-center gap-2 px-3 py-2 text-xs text-secondary shadow-e2">
        <span className="spinner" aria-hidden="true" />
        <span>{message}</span>
      </div>
    </div>
  );
}
